import { PartialDishSupplement } from "../../../../interfaces/meMenuInterfaces/interfaces";
import { SupplementOptionFormValue } from "../modals/SupplementsGroupModal/SupplementsGroupModal";
import { ApolloError } from "@apollo/client";

export const createEmptySupplementOption = (): SupplementOptionFormValue => ({
    uiId: crypto.randomUUID(),
    name: "",
    price: "",
});

export const buildOptionsFromExistingGroup = (existingGroup: PartialDishSupplement): SupplementOptionFormValue[] => {
    const existingOptions = existingGroup?.options ?? [];

    return existingOptions.map((option) => ({
        uiId: crypto.randomUUID(),
        id: option?.id,
        name: option?.name ?? "",
        price: option?.price ?? "",
    }));
};

export const buildDefaultOptionsForCreate = (): SupplementOptionFormValue[] => {
    return [createEmptySupplementOption(), createEmptySupplementOption()];
};

export const getGraphqlErrorCategory = (error: unknown) => {
    const graphQLErrors = (error as ApolloError | undefined)?.graphQLErrors;
    return graphQLErrors?.[0]?.extensions?.category as string | undefined;
};
